import moment from "moment";
export default function formatStocktakeString(item) {
  if (item.bestBeforeDate === "9999-01-01") {
    return `沒有到期日`;
  }
  if (item.bestBeforeDate) {
    return `${moment(item.bestBeforeDate).format("YYYY年MM月")}`;
  }
  if (!item.bestBeforeDate) {
    return `欠貨`;
  }
}
